import { Injectable } from '@angular/core';
import { FacettenUrlService } from '../../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class LernformUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'uf';

  constructor() {
    super(LernformUrlService.URL_PARAMETER, 'uf');
  }
}
